import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import cookies from 'js-cookie';
import { KakaoWorkDept, MyInfo } from '../../types/authData';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AUTH_API,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const xsrfToken = cookies.get('XSRF-TOKEN');
      if (xsrfToken) {
        headers.set('X-XSRF-TOKEN', xsrfToken);
      }
      return headers;
    },
  }),
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    getMyInfo: builder.query<MyInfo, any>({
      query: () => ({ url: '/user/info', method: 'GET' }),
      transformResponse(response: any): Promise<any> {
        return response.data;
      },
      // providesTags: ['Auth'],
    }),
    logout: builder.mutation<any, void>({
      query: () => ({ url: '/logout', method: 'GET' }),
      // invalidatesTags: ['Auth'],
    }),
    getMyInfoFirst: builder.mutation<any, void>({
      query: () => ({ url: `/user/info`, method: 'GET' }),
      transformResponse(response: any): Promise<any> {
        return response.data;
      },
    }),
    getUserData: builder.query<any, any>({
      query: () => ({ url: '/user/data', method: 'GET' }),
      transformResponse(response: any): Promise<any> {
        return response.data;
      },
    }),
    getUserDataMutation: builder.mutation<any, void>({
      query: () => ({ url: '/user/data', method: 'GET' }),
      transformResponse(response: any): Promise<any> {
        return response.data;
      },
    }),
    getUserDetail: builder.query<any, string>({
      query: (id: string) => ({ url: `/user/detail/${id}`, method: 'GET' }),
      transformResponse(response: any): Promise<any> {
        return response.data;
      },
    }),
    getDeptData: builder.query<any, void>({
      query: () => ({ url: '/department/data', method: 'GET' }),
      transformResponse(response: any): Promise<any> {
        return response.data;
      },
    }),
    getDeptList: builder.query<KakaoWorkDept[], void>({
      query: () => ({ url: '/department/list', method: 'GET' }),
      transformResponse(response: any): Promise<any> {
        return response.data;
      },
    }),
  }),
});
export const {
  useGetMyInfoQuery,
  useLogoutMutation,
  useGetUserDataQuery,
  useGetUserDetailQuery,
  useGetDeptDataQuery,
  useGetDeptListQuery,
  useGetMyInfoFirstMutation,
  useGetUserDataMutationMutation,
} = authApi;
